import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { getBillableLeaves } from "../http/requests/project-admin";
import { ProjectAdminType, setVtrackLoader, setBillableLeaves } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerGetBillableLeavesaSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const res = yield call(getBillableLeaves, payload.projectId);
    yield put(setBillableLeaves(res.data));
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* getBillableLeavesSaga() {
  yield takeLatest(
    ProjectAdminType.GET_BILLABLE_LEAVES,
    workerGetBillableLeavesaSaga
  );
}
